// @ts-check
import { objectEntries } from '@erpagroapp/common';

/**
 * @internal
 * @template {import('./types').SettingsConfig} T
 * @param {T} config
 * @returns {{
*   properties: import('./types').EnhancedSettingsConfigProperty<T>
* }}
*/
export function defineConfig(config) {
  const enhancedProperties = /** @type {import('./types').EnhancedSettingsConfigProperty<T>} */ ({});

  objectEntries(config.properties).forEach(([key, prop]) => {
    enhancedProperties[/** @type {keyof T['properties']} */ (key)] = /** @type {any} */ ({
      ...prop,
      resetOnLogout: prop.resetOnLogout ?? false,
    });
  });

  return {
    properties: enhancedProperties,
  };
}
